
import { defineComponent, PropType } from 'vue'
import Calendar from 'primevue/calendar'

import { DatePickerValue, parseDatePickerValue, serializeLocalDate } from './date-picker'

type DatePickerConfig = {
  endOfDay?: boolean
  helpText?: string
  placeholder?: string
}

export default defineComponent({
  name: 'DatePickerInput',
  components: { Calendar },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Date, String, Number] as PropType<DatePickerValue>,
      default: null,
    },
    fieldName: {
      type: String,
      default: undefined,
    },
    config: {
      type: Object as PropType<DatePickerConfig>,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue'],
  computed: {
    selectedDate(): Date | null {
      return parseDatePickerValue(this.modelValue)
    },
  },
  methods: {
    updateValue(value: Date | null): void {
      const config = this.config as DatePickerConfig
      this.$emit('update:modelValue', value == null ? null : serializeLocalDate(value, config.endOfDay === true))
    },
  },
})
